import { render, staticRenderFns } from "./HomepageUserFavorites.vue?vue&type=template&id=5e72b6e6&"
import script from "./HomepageUserFavorites.vue?vue&type=script&lang=js&"
export * from "./HomepageUserFavorites.vue?vue&type=script&lang=js&"
import style0 from "./HomepageUserFavorites.vue?vue&type=style&index=0&id=5e72b6e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports